import { Link } from 'react-router-dom';
import { galleryCategories } from '@/mocks/homeData';

const galleryImages = [
  {
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/03d2b155-bb18-4322-b5ea-e28ef04c548f_compressed_WhatsApp-Image-2026-07-28-at-1.03.10-PM.webp',
    alt: 'Happy Faces — girls community session, Hyderabad',
    label: 'Community Events',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/3cce0a52-a2a7-4e74-930b-aa1a01e46561_compressed_WhatsApp-Image-2026-07-28-at-1.03.12-PM.webp',
    alt: 'Happy Faces — children gathering event, Hyderabad',
    label: 'Community Events',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/ffdcfd54-4b00-4116-a2e7-12ec73716629_compressed_WhatsApp-Image-2026-07-28-at-1.03.13-PM.webp',
    alt: 'Happy Faces Hyderabad Rural Development Welfare Society — official event',
    label: 'Community Events',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/1c7a5be3-d015-4be9-bb55-83c43dd932f3_compressed_WhatsApp-Image-2026-07-28-at-1.03.16-PM.webp',
    alt: 'Happy Faces — children community event with banner',
    label: 'Community Events',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/fcc529ed-7139-48bb-9cb9-20d7d39555df_compressed_WhatsApp-Image-2026-07-28-at-1.03.18-PM.webp',
    alt: 'Happy Faces — boys school outreach visit',
    label: 'Youth Outreach',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Indian%20NGO%20volunteers%20distributing%20thick%20woolen%20blankets%20to%20homeless%20families%20huddled%20at%20outdoor%20shelter%20in%20Hyderabad%20Telangana%20cold%20night%2C%20people%20wrapped%20in%20blankets%20looking%20grateful%2C%20street%20lamps%20glowing%2C%20organized%20distribution%20line%2C%20compassionate%20warm%20scene%2C%20documentary%20photography&width=600&height=600&seq=gallery-blanket-hyd&orientation=squarish',
    alt: 'Blanket distribution drive, Hyderabad',
    label: 'Blanket Distribution',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Hyderabad%20NGO%20food%20distribution%20camp%2C%20volunteers%20in%20matching%20tshirts%20serving%20hot%20meals%20of%20rice%20sambar%20and%20vegetables%20to%20underprivileged%20children%20and%20families%20seated%20in%20rows%2C%20large%20aluminum%20cooking%20vessels%20on%20tables%2C%20Telugu%20signage%20on%20wall%2C%20warm%20community%20atmosphere%2C%20documentary%20photography&width=600&height=600&seq=gallery-food-hyd&orientation=squarish',
    alt: 'Food distribution program, Hyderabad',
    label: 'Food Distribution',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Telangana%20village%20girls%20in%20school%20uniforms%20attending%20education%20awareness%20workshop%20organized%20by%20NGO%20volunteers%2C%20colorful%20educational%20charts%20in%20Telugu%20and%20English%20on%20wall%2C%20girls%20raising%20hands%20enthusiastically%2C%20bright%20cheerful%20classroom%20setting%2C%20empowerment%20and%20learning%20atmosphere%2C%20documentary%20photography&width=600&height=600&seq=gallery-edu-hyd&orientation=squarish',
    alt: 'Education workshop for girls, Telangana',
    label: 'Education',
  },
];

export default function GallerySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-50 text-accent-600 text-xs font-semibold rounded-full mb-3">
            Our Gallery
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Moments of{' '}
            <span className="gradient-text">Impact & Change</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Real moments from Happy Faces Hyderabad. Every photo captures lives we have touched across the community.
          </p>
        </div>

        {/* Category pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-8">
          {galleryCategories.map((cat, index) => (
            <button
              key={index}
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-100 hover:bg-primary-50 text-foreground-600 hover:text-primary-600 text-xs font-medium rounded-full transition-all duration-200 whitespace-nowrap border border-transparent hover:border-primary-200"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
              <span className="text-foreground-400 ml-0.5">({cat.count})</span>
            </button>
          ))}
        </div>

        {/* Photo grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.map((img, index) => (
            <Link
              key={index}
              to="/gallery"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer ${
                index === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
              }`}
              style={{ aspectRatio: index === 0 ? 'auto' : '1/1', minHeight: index === 0 ? '340px' : undefined }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ height: index === 0 ? '100%' : undefined }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3 md:p-4">
                <span className="text-accent-300 text-[10px] font-bold uppercase tracking-wide mb-1">{img.label}</span>
                <p className="text-white text-xs md:text-sm font-medium leading-snug">{img.alt}</p>
              </div>
              {/* Real photo badge for first 5 */}
              {index < 5 && (
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500/90 backdrop-blur-sm">
                  <span className="text-white text-[9px] font-bold uppercase tracking-wide">Live</span>
                </div>
              )}
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-image-line"></i>
            Explore Full Gallery
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}